import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span class="slex-stat-character"><span class="slex-stat-character-current"> </span></span>`);
var root_1 = $.from_html(`<span class="slex-stat-unit"> </span>`);
var root_2 = $.from_html(`<div class="slex-stat"><div class="slex-stat-label"><!> <span> </span></div> <div class="slex-stat-value"><span class="slex-stat-number"></span> <!></div></div>`);

export default function Stat($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let previousDisplayValue = $.state("");
	let currentDisplayValue = $.state("");
	let valueChange = $.state("changed");
	let hasDisplayValue = false;
	let shouldAnimateValue = $.state(false);
	let valueAnimationPhase = $.state("update");
	const valueText = $.derived(() => text($.get(p).value));
	const valueSegments = $.derived(() => statSegments($.get(previousDisplayValue), $.get(currentDisplayValue)));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function numericValue(value) {
		const parsed = Number.parseFloat(value.replaceAll(",", ""));

		return Number.isFinite(parsed) ? parsed : null;
	}

	function changeDirection(previous, next) {
		const previousNumber = numericValue(previous);
		const nextNumber = numericValue(next);

		if (previousNumber === null || nextNumber === null) return "changed";
		if (nextNumber > previousNumber) return "up";
		if (nextNumber < previousNumber) return "down";

		return "changed";
	}

	function booleanProp(value) {
		return value === true || value === "true" || value === 1 || value === "1";
	}

	function initialPreviousValue(value) {
		return Array.from(value).map((char) => isDigit(char) ? "0" : char).join("");
	}

	$.user_effect(() => {
		const next = $.get(valueText);

		if (!hasDisplayValue) {
			$.set(shouldAnimateValue, booleanProp($.get(p).animateInitial), true);
			$.set(previousDisplayValue, $.get(shouldAnimateValue) ? initialPreviousValue(next) : next, true);
			$.set(currentDisplayValue, next, true);
			$.set(valueChange, "up");
			$.set(valueAnimationPhase, "initial");
			hasDisplayValue = true;

			return;
		}

		if (next === $.get(currentDisplayValue)) return;

		$.set(valueChange, changeDirection($.get(currentDisplayValue), next), true);
		$.set(previousDisplayValue, $.get(currentDisplayValue), true);
		$.set(currentDisplayValue, next, true);
		$.set(shouldAnimateValue, true);
		$.set(valueAnimationPhase, "update");
	});

	function isDigit(char) {
		return (/^[0-9]$/).test(char);
	}

	function statSegments(previous, current) {
		const previousChars = Array.from(previous);
		const currentChars = Array.from(current);
		const currentOffset = Math.max(0, currentChars.length - previousChars.length);
		const previousOffset = Math.max(0, previousChars.length - currentChars.length);

		return currentChars.map((char, index) => {
			const previousChar = previousChars[index - currentOffset + previousOffset] ?? "";

			return {
				char,
				previousChar,
				changed: previousChar !== char,
				key: `${index}:${char}`,
				kind: isDigit(char) ? "digit" : "symbol"
			};
		});
	}

	var div = root_2();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			InlineIcon($$anchor, {
				get name() {
					return $.get(p).icon;
				},
				className: 'slex-stat-icon'
			});
		};

		$.if(node, ($$render) => {
			if ($.get(p).icon) $$render(consequent);
		});
	}

	var span = $.sibling(node, 2);
	var text_1 = $.child(span, true);

	$.reset(span);
	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var span_1 = $.child(div_2);

	$.each(span_1, 21, () => $.get(valueSegments), (segment) => segment.key, ($$anchor, segment) => {
		var span_2 = root();
		var span_3 = $.child(span_2);
		var text_2 = $.child(span_3, true);

		$.reset(span_3);
		$.reset(span_2);

		$.template_effect(() => {
			$.set_attribute(span_2, 'data-stat-kind', $.get(segment).kind);
			$.set_attribute(span_2, 'data-stat-change', $.get(segment).changed && $.get(shouldAnimateValue) ? $.get(valueChange) : undefined);
			$.set_attribute(span_2, 'data-stat-initial', $.get(segment).changed && $.get(shouldAnimateValue) && $.get(valueAnimationPhase) === "initial" ? "true" : undefined);
			$.set_attribute(span_2, 'data-stat-previous', $.get(segment).previousChar || undefined);
			$.set_text(text_2, $.get(segment).char);
		});

		$.append($$anchor, span_2);
	});

	$.reset(span_1);

	var node_1 = $.sibling(span_1, 2);

	{
		var consequent_1 = ($$anchor) => {
			var span_4 = root_1();
			var text_3 = $.child(span_4, true);

			$.reset(span_4);
			$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(p).unit)]);
			$.append($$anchor, span_4);
		};

		$.if(node_1, ($$render) => {
			if ($.get(p).unit) $$render(consequent_1);
		});
	}

	$.reset(div_2);
	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_attribute(div, 'data-tone', $0);
			$.set_text(text_1, $1);
		},
		[
			() => $.get(p).tone || $.get(p).type ? text($.get(p).tone ?? $.get(p).type) : undefined,
			() => text($.get(p).label ?? $$props.componentName)
		]
	);

	$.append($$anchor, div);
	$.pop();
}